import React, { useEffect } from 'react';
import { IconButton, Inline } from '@99designs/emu';
import { IconAnnotate1, IconSketch1, IconUndo1 } from '@99designs/icons';
import { trackEvent } from '@99designs/tracking';
import { useFeedbackModeContext } from '../../FeedbackModeProvider/FeedbackModeProvider';

interface FeedbackControlsProps {
    canAnnotate: boolean;
    canScribble: boolean;
    isScribbleLoading: boolean; // TODO: to come from future ScribbleContext
    canUndoSketch: boolean; // TODO: to come from future ScribbleContext
    disabled?: boolean;
    undoSketch: () => void; // TODO: to come from future ScribbleContext
}

function FeedbackControls({
    canAnnotate,
    canScribble,
    isScribbleLoading,
    canUndoSketch,
    disabled,
    undoSketch,
}: FeedbackControlsProps) {
    const { feedbackMode, setFeedbackMode } = useFeedbackModeContext();

    useEffect(() => {
        if (!(canAnnotate || canScribble)) {
            setFeedbackMode('none');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canAnnotate, canScribble, feedbackMode]);

    useEffect(() => {
        if (canAnnotate && feedbackMode === 'none') {
            setFeedbackMode('annotate');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canAnnotate]);

    return (
        <Inline space="none">
            {canUndoSketch && (
                <IconButton
                    aria-label={__('Undo')}
                    onClick={undoSketch}
                    icon={IconUndo1}
                    appearance="transparent"
                    disabled={disabled}
                />
            )}
            {canScribble && (
                <IconButton
                    aria-label={__('Draw')}
                    onClick={() => {
                        trackEvent('Clicked on scribbles tool');
                        setFeedbackMode('sketch');
                    }}
                    selected={feedbackMode === 'sketch'}
                    icon={IconSketch1}
                    appearance="transparent"
                    loading={isScribbleLoading}
                    disabled={disabled}
                />
            )}
            {canAnnotate && (
                <IconButton
                    aria-label={__('Comment')}
                    onClick={() => {
                        trackEvent('Clicked on annotation tool');
                        setFeedbackMode('annotate');
                    }}
                    selected={feedbackMode === 'annotate'}
                    appearance="transparent"
                    icon={IconAnnotate1}
                    disabled={disabled}
                />
            )}
        </Inline>
    );
}

export default FeedbackControls;
